/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Sending/view.blocks to change it.
import LoaderThreeDots from 'DesignSystem/LoaderThreeDots/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Sending({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Sms/Content/Outbound/Info/MessageStatus/Sending"
  
}) {
  return (<React.Fragment
>
<LoaderThreeDots
  viewPath={`${viewPath}/LoaderThreeDots`}
/>
{children}
</React.Fragment>)
}